import React, { useState, useEffect } from 'react';
import PageHeading from '../../components/PageHeading';
import { HistoryOutlined, SearchOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Table, Input, message, Tag, Empty, Typography } from 'antd';
import axiosInstance from '../../utils/axios';

const { Text } = Typography;

const EventCompletedShows = () => {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchCompletedShows(pagination.current, search);
  }, [pagination.current, search]);

  const fetchCompletedShows = async (page = 1, searchTerm = '') => {
    setLoading(true);
    try {
      let url = `news_and_events/event-shows/history/?page=${page}&page_size=${pagination.pageSize}`;
      if (searchTerm.trim()) {
        url += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      const response = await axiosInstance.get(url);

      setShows(response.data.results || []);
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.count || 0,
      }));
    } catch (error) {
      message.error('Failed to load completed event shows');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Movie',
      dataIndex: 'movie',
      key: 'movie',
      render: (movie) => <strong>{movie || '—'}</strong>,
    },
    {
      title: 'Screen',
      dataIndex: 'screen',
      key: 'screen',
      render: (screen) => screen || '—',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => (date ? new Date(date).toLocaleDateString('en-IN') : '—'),
    },
    {
      title: 'Time Slot',
      dataIndex: 'timeslot',
      key: 'timeslot',
      render: (timeslot) => timeslot || '—',
    },
    {
      title: 'Show Time',
      key: 'show_time',
      render: (_, record) => (
        <Text>
          <ClockCircleOutlined style={{ marginRight: 6 }} />
          {record.start_time} - {record.end_time}
        </Text>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color="default">{status || 'Completed'}</Tag>
      ),
    },
  ];

  return (
    <div className="dashboard">
      <PageHeading name="Completed Shows" icon={<HistoryOutlined />} />

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16,
        }}
      >
        <Input
          placeholder="Search by movie name"
          prefix={<SearchOutlined />}
          style={{ width: '240px' }}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPagination((prev) => ({ ...prev, current: 1 }));
          }}
        />

        <Text type="secondary">
          Past shows from <strong>your event</strong>
        </Text>
      </div>

      <Table
        dataSource={shows}
        columns={columns}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          onChange: (page) => {
            setPagination((prev) => ({ ...prev, current: page }));
          },
        }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No completed shows for this event"
            />
          ),
        }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default EventCompletedShows;

